// this just stores data on the window object for now.
// this is useful for large datasets that don't change
// or might otherwise bog down Redux.
const store = window.store ||= {};

export const getStore = () => store;
